export default {
  CUSTOMER: 1,
  BANKING: 2,
  INSURANCE: 3,
  DAMAGE: 4,
  MORTGAGE: 5,
  MAILING: 6,
  DOSSIER: 7,
  CREDIT: 8,
  INCOME: 9,
  RETIREMENT: 10,
  POSSESSION: 11,
  OBLIGATION: 12,
  CURRENT_LIVING_CONDITION: 13,
  TENANT: 14,
  AGENCY: 15,
  TASK: 16,
  CUSTOMER_PORTAL: 17,
  ASSESSMENT_PORTAL: 18,
};
